// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"cbb50643","446":"6d4601bf","583":"0e159f8b","862":"6f42e92b","944":"1ec7880f"}[chunkId] + ".chunk.js";
};